import withSuspense from '@/infrastructure/hoc/withSuspense';
import { lazy } from 'react';
import SkeletonStack from '../SkeletonStack';

export default withSuspense(
  lazy(() => import('./MarkdownRenderer')),
  SkeletonStack,
);
